import { formatBytes, formatDate } from "rant-utils";
import { api } from "../api/api"
import { HistoricalDate } from "../core/ui/HistoricalDate";
import { Icon } from "../core/ui/icons";
import { getObjectValue } from "../core/utils/objectPath";
import { FormFeatureType, getFormFeatureTypeName } from "../data-entry/types";
import { Company, EntityData, getEntityTypeName } from "../types";
import { formatAusPhoneNumber } from "../formatters/format";


export function CustomCol(props: {
	className?: string,
	title: (c: any) => any,
	value: (r: any, c: any) => any,
}) {
	return props;
}

export function GenericCol(title: string, prop: string, className?: string) {
	return {
		className,

		title: (c: any) => {
			return title;
		},
		
		value: (r: any, c: any) => {
			const val = getRowVal(r, prop);
			return val;
		}	
	};
}

export function AusPhoneNumberCol(title: string, prop: string, className?: string) {
	return {
		className,

		title: (c: any) => {
			return title;
		},
		
		value: (r: any, c: any) => {
			const val = getRowVal(r, prop);
			return <div>{formatAusPhoneNumber(val)}</div>;
		}	
	};
}


// const idFormats = [
// 	"tag",
// 	"tag secondary",
// 	"tag subtle",
// ];

export function IDCol() {
	return {
		title: (c: any) => {
			return "ID";
		},
		
		value: (r: any, c: any) => {
			const parts = r.id.split("-");
			const items = [];
			let i = 0;
			for(let p of parts) {
				const cls = "tag"; //(i < idFormats.length) ? idFormats[i] : "";
				items.push(
					<span key={i} className={cls}>{p}</span>
				)
				i++;
			}

			return (
				<div
					className="flex horiz gap-2"
					onClick={(e) => {
						navigator.clipboard.writeText(r.id).then(() => {
							
						});
						e.stopPropagation();
					}}
				>{items}</div>
			);
		}	
	};
}
export function TitleCol(title?: string) {
	return GenericCol(title ? title : "Title", "title");
}

export function VersionCol() {
	return {
		className: "align-center",

		title: (c: any) => {
			return "Version";
		},
		
		value: (r: any, c: any) => {
			return <div className="tag subtle">{r.version}</div>;
		}	
	};
}

export function CopyToClipboardCol(prop?: string) {
	return {
		className: "align-center",

		title: (c: any) => {
			return "Copy";
		},
		
		value: (r: any, c: any) => {
			let val = prop ? r[prop] : r;
			val = JSON.stringify(val, null, 4);

			return (
				<button
					className="flat"
					onClick={(e) => {
						navigator.clipboard.writeText(val).then(() => {
							
						});
						e.stopPropagation();
						return false;
					}}
				>
					<Icon type="copy" />
				</button>
			);
		}	
	};
}

export function SizeBytesCol() {
	return {
		className: "align-center",

		title: (c: any) => {
			return "Size";
		},
		
		value: (r: any, c: any) => {
			return formatBytes(r.sizeBytes);
		}	
	};
}

function getRowVal(r: any, prop: string) {
	if (!r) return;
	
	if (prop.indexOf(".") > 0) {
		return getObjectValue(r, prop);
	} else {
		return r[prop];
	}
}

export function DateCol(title: string, prop: string) {
	return {
		className: "align-center",

		title: (c: any) => {
			return title;
		},

		value: (r: any, c: any) => {
			const val = getRowVal(r, prop);
			if (!val) return "";
			return formatDate(val);
		}	
	};

}

export function LastUpdatedCol(props?: {
	className?: string,
}) {
	return {
		className: "align-center " + ((props && props.className) ? props.className : ""),

		title: (c: any) => {
			return "Last Updated";
		},

		value: (r: any, c: any) => {
			return <HistoricalDate dt={r.updated ? r.updated : r.created} />
		}	
	};
}

export function EntityTypeCol() {
	return {
		title: (c: any) => {
			return "Type";
		},
		value: (r: any, c: any) => {
			const e = r.data as EntityData;
			let type = e.type;
			if (type) {
				return <div className="tag subtle">{getEntityTypeName(type)}</div>;
			}
		}	
	}
}

export function FormFeatureTypeCol() {
	return {
		title: (c: any) => {
			return "Type";
		},
		value: (r: any, c: any) => {
			const type = r.type as FormFeatureType;
			if (type) {
				return getFormFeatureTypeName(type);
			}
		}	
	}
}

export function ACNCol() {
	return {
		title: (c: any) => {
			return "ACN";
		},
		value: (r: any, c: any) => {
			const e = r.data as EntityData;
			const company = e as Company;
			if (company.acn) {
				return <div className="tag subtle">{company.acn}</div>;
			}
		}	
	}
}

export function ShareCountCol() {
	return {
		title: (c: any) => {
			return "Count";
		},
		value: (r: any, c: any) => {
			const e = r as any;
			const count = e.shareCount;
			if (count > 0) {
				return <div className="tag success">+ {count}</div>;
			} else {
				return <div className="tag error">- {Math.abs(count)}</div>;
			}
		}	
	}
}


export function TagCol(title: string, prop: string, formatVal?: (val: any) => any) {
	return {
		title: (c: any) => {
			return title;
		},
		value: (r: any, c: any) => {
			let val = getRowVal(r, prop);
			if (formatVal) val = formatVal(val);
			if (val) {
				return <div className="tag subtle">{val}</div>;
			}
		}	
	}
}

export function TagsCol() {
	return {
		title: (c: any) => {
			return "Tags";
		},
		value: (r: any, c: any) => {
			if (!r.meta || !r.meta.tags) return;
			const result = [];
			for(let t of r.meta.tags) {
				result.push(
					<div className="tag subtle" key={t}>{t}</div>
				)
			}
			return result;
		}	
	}
}

export function SyncTableCol(props: {
	container: string,
	onSync: () => void,
}) {
	const isProd = (document.location.href.toLowerCase().indexOf("guardiacorp") >= 0);

	return {
		className: "align-center",
		title: (c: any) => {
			return (isProd ? "Synced Version" : "Sync to Prod");
		},
		value: (r: any, c: any) => {
			return (
				<SyncCell container={props.container} obj={r} isProd={isProd} onSync={props.onSync} />
			);
		}	
	};
}

export function SyncCell(props: {
	container: string,
	obj: any,
	isProd: boolean,
	onSync: () => void,
}) {
	const obj = props.obj;
	const cls = (obj.lastSync !== obj.version) ? "primary" : "flat";

	if (props.isProd) {
		// on prod just report back what the last sync version number was
		return (obj.lastSync ? <div className="tag">{obj.lastSync}</div> : <i>Never</i>);

	} else {
		// on dev env give option to sync to prod
		return <>
			<button
				className={cls}
				key="sync-up"
				onClick={(e) => {
					api.sync_to_prod({
						container: props.container,
						id: obj.id,
					}).then(() => {
						props.onSync();
					}).catch(() => {
	
					});
	
					e.stopPropagation();
				}}
			><Icon type="arrowUp" /></button>
			<button
				className={"flat"}
				key="sync-down"
				onClick={(e) => {
					api.sync_from_prod({
						container: props.container,
						id: obj.id,
					}).then(() => {
						props.onSync();
					}).catch(() => {
	
					});
	
					e.stopPropagation();
				}}
			><Icon type="arrowDown" /></button>
		</>;
	}

}

export function CombineColumns(props: {
	title: string,
	cols: any[],
}) {
	return {
		title: (c: any) => {
			return props.title;
		},
		
		value: (r: any, c: any) => {
			const result = [];

			for(let col of props.cols) {
				result.push(
					col.value(r, col)
				)
			}

			return (
				<div>
					{result}
				</div>
			);
		}	
	};
}